import { DeploymentOverview } from '@/types/deploymentGroup'

export const getGroupGpuIndexes = (
  overview: DeploymentOverview | undefined,
  deviceId: string
): number[] => {
  const indexes = new Set<number>()

  overview?.results.forEach(({ devices }) =>
    devices
      .filter((device) => device.device_id === deviceId)
      .forEach(({ groups }) =>
        groups.forEach(({ gpu }) => {
          if (gpu) {
            indexes.add(gpu.index)
          }
        })
      )
  )

  return [...indexes].sort((a, b) => a - b)
}
